import { Button, Modal, Form, Input, Upload, message, InputNumber } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { MyValidateMessages } from "../../../../utils/validateMessaage";
import "./editorModal.css";
import { changeBanner, uploadImg } from "../../../../api/api";
import { useEffect } from "react";
import UploadOnePicture from "../../../../components/upLoadOnePicture/uploadPicture";

export default function EditorModal(props) {
  //表单设置
  const { TextArea } = Input;
  const [componentDisabled, setComponentDisabled] = useState(false);
  const onFormLayoutChange = ({ disabled }) => {
    setComponentDisabled(disabled);
  };
  const [form] = Form.useForm();
  const [total, setTotal] = useState(props.total);

  //modal设置
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  //向父组件传递图片网址
  const [url, setUrl] = useState();
  const setImgUrl = (url) => {
    setUrl(url);
    // console.log(url);
  };
  const info = props.swiperDetail;
  const setIsFresh = props.setIsFresh;

  useEffect(() => {
    console.log("info", info);
    setUrl(info.image);
  }, []);

  const showModal = () => {
    setOpen(true);
  };
  const handleOk = () => {
    form.setFieldValue("image", url);
    console.log(url);
    form.validateFields().then((res) => {
      const params = Object.assign(res, { id: info.id });
      changeBanner(params).then((res) => {
        console.log(res);
        setOpen(false);
        setIsFresh((pre) => {
          return !pre;
        });
        message.success("轮播图修改成功！");
      });
    });
  };
  const handleCancel = () => {
    console.log("Clicked cancel button");
    setOpen(false);
  };

  return (
    <>
      <a onClick={showModal}>编辑</a>
      <Modal
        title="编辑轮播图"
        okText="确定"
        cancelText="取消"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <Form
          validateMessages={MyValidateMessages}
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          layout="horizontal"
          onValuesChange={onFormLayoutChange}
          disabled={componentDisabled}
          form={form}
          initialValues={info}
        >
          <Form.Item
            label="轮播图名称"
            name="title"
            rules={[
              {
                required: true,
                max: 10,
              },
            ]}
          >
            <Input placeholder="上限10字" />
          </Form.Item>

          <Form.Item
            label="轮播图顺序"
            name="position"
            rules={[
              {
                type: "number",
                required: true,
                max: 5,
                min: 1,
              },
            ]}
          >
            <InputNumber
              style={{ width: "18vw" }}
              placeholder="请输入1-5的数字"
            />
          </Form.Item>

          <Form.Item
            label="轮播图URL"
            name="redirect"
            // rules={[
            //   {
            //     required:true,
            //   }
            // ]}
          >
            <TextArea
              rows={4}
              placeholder="请输入需要跳转的小程序页面URL或公众号文章链接"
            />
          </Form.Item>

          <Form.Item
            label="轮播图图片"
            valuePropName="image"
            name="image"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <UploadOnePicture deliverUrl={setImgUrl} image={info.image} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
